import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/chainsReducer";
import rootSaga from "./redux/chainsSagas";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { ChainsModule } from "./ChainsModule";

const Chains = (props) => {
  const { notifications, ...rest } = props;

  return (
    <Provider store={createReduxStore(reducer, "chains", rootSaga)}>
      <ErrorBoundary moduleName="chains" {...notifications}>
        <ChainsModule params={rest} />
      </ErrorBoundary>
    </Provider>
  );
};

export default Chains;
